import { Provider } from "@angular/core";
import { ShellService } from "./services";

export function provideShellService(): Array<Provider>
{
    return [ShellService];
}
